const state = {
    heading: '',
    filters: {
        municipalities: {
            title: 'Filtrera på kommun',
            showAll: 'Alla kommuner',
            options: [],
        },
        historyTypes: {
            title: 'Filtrera på intressen',
            showAll: 'Alla intressen',
            options: [],
        },
        eras: {
            title: 'Filtrera på tidsepok',
            showAll: 'Alla tidsepoker',
            options: [],
        },
    },
    histories: [],
    fallbackImage: {
        src: '',
        alt: ''
    },
    distPath: '',
    zoom: 10,
    defaultZoom: 10,
    view: 'roadmap',
    position: {
        lat: 59.329323,
        lng: 18.068581
    },
    defaultPosition: {
        lat: 59.329323,
        lng: 18.068581
    },
    listView: 'list',
    page: 1,
    postsPerPage: 9,
    selectedDestination: null,
    userLocationIcon: '',
    mapKey: '',
    mapId: '',
    icon: '',
    selected: null,
    iconDefaultColor: '',
    cookieAccepted: false,
    route: [],
    filteredDestinations: [],
    filtersChanged: null,
}

export default state;